import { render, staticRenderFns } from "./swiperVideoList.vue?vue&type=template&id=4832eae8&scoped=true&"
import script from "./swiperVideoList.vue?vue&type=script&lang=js&"
export * from "./swiperVideoList.vue?vue&type=script&lang=js&"
import style0 from "./swiperVideoList.vue?vue&type=style&index=0&id=4832eae8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4832eae8",
  null
  
)

export default component.exports